import { GenericValue } from 'hisng';
import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';

@Component( {
    selector: 'erp-pbw-akad-grad',
    templateUrl: './with-datasource.component.html'
} )
export class AcademicDegreeFormComponent extends WithDatasourceComponent<GenericValue> {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/person/value/academicdegree',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.academicDegree',
            } );
    }

    set value( t: GenericValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.academicDegree = t;
        }
    }

    get value(): GenericValue | undefined {
        return this.jobapplication?.academicDegree;
    }

    getFieldValue( t?: GenericValue ): string | undefined {
        return t?.text;
    }
}
